import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { BUTTON_TYPES } from '@shared/components/button/button-types.enum';
import { ButtonComponent } from '@shared/components/button/button.component';
import { DialogRef } from '@angular/cdk/dialog';
import { MatButton } from '@angular/material/button';
import { MatDialogClose } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-delete-account-modal',
  imports: [
    ButtonComponent,
    MatButton,
    MatDialogClose,
    TranslateModule,
  ],
  templateUrl: './delete-account-modal.component.html',
  styleUrl: './delete-account-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeleteAccountModalComponent {
  dialogRef = inject<DialogRef<string>>(DialogRef<string>);
  protected readonly ButtonTypes = BUTTON_TYPES;

  closeModal(): void {
    this.dialogRef.close();
  }
}
